import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { staticStat } from '@/api/index';
import type { IRequestBodyFilter } from '@/api/routes/static-devices/types';

import { statStaticAdFilters } from './mocks';

export const fetchStaticAdFilters = createAsyncThunk(
  'staticAdFilters',
  async (params: IRequestBodyFilter, thunkAPI) => {
    try {
      const response = await staticStat.getStaticAdFilters(params);
      return response ? response.data : statStaticAdFilters;
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
